module.exports = __webpack_public_path__ + "img/crypto_dis.8642a21b.png";